import { DateTime } from 'luxon';

/** Período de padrón en formato ISO corto: "2026-07". */
export type PeriodIso = string;

const parsePeriod = (period: PeriodIso): DateTime =>
  DateTime.fromFormat(period, 'yyyy-MM', { locale: 'es' });

/** "2026-07" → "julio 2026" (texto informativo). */
export const periodToLongLabel = (period: PeriodIso): string => {
  const parsed = parsePeriod(period);
  return parsed.isValid ? parsed.toFormat('LLLL yyyy') : period;
};

/** "2026-07" → "Jul-2026" (celda de tabla). */
export const periodToShortLabel = (period: PeriodIso): string => {
  const parsed = parsePeriod(period);
  if (!parsed.isValid) return period;
  const month = parsed.toFormat('LLL').replace('.', '');
  return `${month.charAt(0).toUpperCase()}${month.slice(1)}-${parsed.toFormat('yyyy')}`;
};

/** "2026-07" → "Jul" (eje del gráfico, donde el año no cabe). */
export const periodToMonthLabel = (period: PeriodIso): string => {
  const parsed = parsePeriod(period);
  if (!parsed.isValid) return period;
  const month = parsed.toFormat('LLL').replace('.', '');
  return `${month.charAt(0).toUpperCase()}${month.slice(1)}`;
};

export const buildRecentPeriods = (count: number, reference?: PeriodIso): PeriodIso[] => {
  const base = reference ? parsePeriod(reference) : DateTime.now();
  if (!base.isValid || count <= 0) return [];

  return Array.from({ length: count }, (_, index) =>
    base.minus({ months: index }).toFormat('yyyy-MM'),
  );
};
